import { useResizeObserver } from "@vueuse/core";
import { computed, ref } from "vue";
import { toBoolean, toNumber } from "#ce/utils/props";

function positiveInteger(value, fallback = 1) {
  const number = toNumber(value);
  return Number.isFinite(number) && number >= 1 ? Math.floor(number) : fallback;
}

function parseBreakpoints(value) {
  if (typeof value !== "string") {
    return value ?? {};
  }
  try {
    return JSON.parse(value) ?? {};
  } catch {
    return {};
  }
}

export function useSliderOptions(target, props) {
  const width = ref(0);
  useResizeObserver(target, ([entry]) => {
    width.value = entry.contentRect.width;
  });

  const options = computed(() => {
    const settings = {
      slidesPerView: props.slidesPerView,
      slidesToScroll: props.slidesToScroll,
      arrows: props.arrows,
    };
    const breakpoints = parseBreakpoints(props.breakpoints);
    for (const min of Object.keys(breakpoints).sort((a, b) => Number(a) - Number(b))) {
      if (Number.isFinite(Number(min)) && Number(min) >= 0 && width.value >= Number(min)) {
        Object.assign(settings, breakpoints[min]);
      }
    }
    return {
      slidesPerView: settings.slidesPerView === undefined ? undefined : positiveInteger(settings.slidesPerView),
      slidesToScroll: positiveInteger(settings.slidesToScroll),
      arrows: toBoolean(settings.arrows),
    };
  });

  return options;
}
